import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { AppConstant } from "src/app/app.constant";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DataResult, DataSourceRequestState } from "@progress/kendo-data-query";
import { LoaderService } from "src/app/_metronic/partials/content/loader/loader.service";
import { Attachment } from "src/app/_metronic/core/classes/core.class";
import { ToasterService, ToasterType } from "src/app/services/toaster/toaster.service";
import { ReportCardConfigStep2 } from "./report-card.classes";

@Injectable()
export class ReportCardService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant, private toasterService: ToasterService) {
        this.apiUrl = this.appConstant.getUrl()
    }

    public getExamNamesForReportCard(filter): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getExamNamesForReportCard/`, filter).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    public manageReportCardConfigStep1(configData): Observable<any> {
        return this.httpClient.post(`${this.apiUrl}/manageReportCardConfigStep1/`, configData).pipe(
            map((response: any) => {
                return {
                    data: response.data as {},
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<any>
    }
    public manageReportCardConfigStep2(configData): Observable<any> {
        return this.httpClient.post(`${this.apiUrl}/manageReportCardConfigStep2/`, configData).pipe(
            map((response: any) => {
                return {
                    data: response.data as {},
                    total: response.total,
                } as GridDataResult;
            })
        ) as any as Observable<any>;
    }
    manageReportCardConfigStep3(configData): Observable<any> {
        return this.httpClient.post(`${this.apiUrl}/manageReportCardConfigStep3/`, configData).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    public getAllStep3Data(reportConfigId): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getReportCardConfigStep3/${reportConfigId}`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total,
                } as GridDataResult;
            })
        ) as any as Observable<GridDataResult>;
    }
    public getAllReportCardConfig(state): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllReportCardConfig/`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    async getReportCardConfigStep1ById(Id): Promise<any> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getReportCardConfigStep1ById/` + Id).toPromise()).data;
    }
    async getReportCardConfigStep2ById(Id): Promise<any> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getReportCardConfigStep2ById/` + Id).toPromise()).data;
    }

    async getReportCardConfigStep2(configData): Promise<any> {
        return (await this.httpClient.post<GridDataResult>(`${this.apiUrl}/getReportCardConfigStep2/`, configData).toPromise()).data;
    }

    async getAllReportCardConfigExamTypes(Id): Promise<any> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllReportCardConfigExamTypes/` + Id).toPromise()).data;
    }
    async getAllReportCard(): Promise<any> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllReportCard/`).toPromise()).data;
    }
    async generateReportCard(reportConfigId): Promise<any> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/generateReportCard/` + reportConfigId).toPromise()).data;
    }
}
